import React from 'react';
import { Box, Button, Text, TextInput } from '@mantine/core';

import ErrorAlert from '@/components/ErrorAlert';
import { UseFormReturnType } from '@mantine/form';
import { FormValues } from './useForgotPasswordEmail';

interface ForgotPasswordEmailSuccessProps {
  onSubmit: () => void;
  form: UseFormReturnType<FormValues>;
  loading: boolean;
  error: string;
}

const ForgotPasswordEmailContext: React.FC<ForgotPasswordEmailSuccessProps> = ({
  onSubmit,
  form,
  loading,
  error,
}) => {
  return (
    <>
      <Text fz="2rem" fw="bold" mt="sm">
        Forgot your password?
      </Text>
      <Text>
        It happens! Just confirm your email address and we'll send you a link to reset your
        password.
      </Text>
      {error && (
        <Box>
          <ErrorAlert>{error}</ErrorAlert>
        </Box>
      )}
      <form onSubmit={onSubmit}>
        <TextInput
          mt="sm"
          placeholder="Enter your email"
          size="lg"
          label="Email"
          withAsterisk
          autoFocus
          autoComplete="email"
          disabled={loading}
          {...form.getInputProps('email')}
        />
        <Button mt="sm" size="lg" fullWidth type="submit" loading={loading}>
          Send reset email
        </Button>
      </form>
    </>
  );
};

export default ForgotPasswordEmailContext;
